module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class=\'search-dropdown-item\' data-index=\'' +
((__t = ( index )) == null ? '' : __t) +
'\'>\n';
 if (type == "BudgetLine") { ;
__p += '\n    <span class="item-title">\n        <span class="glyphicon glyphicon-book" aria-hidden="true"></span>\n        ' +
((__t = ( title )) == null ? '' : __t) +
' <small>(' +
((__t = ( year )) == null ? '' : __t) +
')</small></span>\n    <span class="item-code">' +
((__t = ( code.slice(2) )) == null ? '' : __t) +
'</span>\n';
 } else if (type == "Entity") { ;
__p += '\n    <span class="item-title">\n        <span class="glyphicon glyphicon-briefcase" aria-hidden="true"></span>\n        ' +
((__t = ( name.replace(/\"/g,"'") )) == null ? '' : __t) +
'</span>\n    <span class="item-code">' +
((__t = ( id )) == null ? '' : __t) +
'</span>\n';
 } ;
__p += '\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/search-dropdown-item.html
// module id = 138
// module chunks = 0